import React, { useEffect, useState, useRef } from "react"
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'
import Draggable from 'react-draggable';

const HivemindArchive = ({ gallery, backgroundImage }) => {
  const [activePost, setActivePost] = React.useState(0)
  const [popup, setPopup] = React.useState(false)

  const togglePopup = (i) => {
    setActivePost(i);
    setPopup(!popup);
  };

  const props = {
    onMouseEnter: () => window?._handleMouseEnter('Zoom'),
    onMouseLeave: () => window?._handleMouseLeave(),
  }

  // useEffect(() => {
  //   const Isotope = require('isotope-layout')
  //   setTimeout(() => {
  //     new Isotope('.hivemind-block__grid', {
  //       percentPosition: true,
  //       itemSelector: '.grid-item',
  //       masonry: {
  //         columnWidth: '.grid-sizer',
  //         gutter: '.gutter-sizer',
  //         horizontalOrder: true,
  //       },
  //     });
  //   }, 100);
  // }, []);


  const dividedGallery = Array.from(
    { length: Math.ceil(gallery.length / 6) },
    (_, index) => gallery.slice(index * 6, index * 6 + 6)
  );

  return (
    <>
      {/*style={{backgroundImage: `url('${backgroundImage?.localFile.childImageSharp.gatsbyImageData.images.fallback.src}')`}}*/}
      <section className="hivemind-block">
        { backgroundImage?.localFile && <div className='hivemind-block__bg'><GatsbyImage image={getImage(backgroundImage.localFile)} alt={backgroundImage.altText} /></div> }
        <div className="hivemind-block__inner">
          <div className="hivemind-block__grid">
            {/*<div className="grid-sizer"></div>*/}
            {/*<div className="gutter-sizer"></div>*/}

            { dividedGallery.map((row, rowIndex) => (
             <div className='hivemind-block__wrapper'>
               {
                 row.map((el, i) => (
                     <button key={i + rowIndex * 6} className="grid-item"
                             onClick={() => togglePopup(i + rowIndex * 6)} {...props}>
                       <Fade distance="40px" bottom>
                         <>
                           {el?.localFile && <GatsbyImage draggable="false" image={getImage(el.localFile)} alt={el.altText} />}
                         </>
                       </Fade>
                     </button>
                 ))
               }
             </div>
            ))}
          </div>
        </div>
      </section>
      <div className={`popup${popup ? " active" : ""}`}>
        <div className="popup__close-bg" onClick={() => setPopup(false)}></div>
        <div className="popup__wrapper">
          <div className="popup__image">
            {gallery[activePost].localFile &&
              <GatsbyImage image={getImage(gallery[activePost].localFile)} alt={gallery[activePost].altText} /> }
            { gallery[activePost].caption && <div className='popup__caption'>{parse(gallery[activePost].caption)}</div> }
          </div>
        </div>
      </div>
    </>
  )
}

export default HivemindArchive
